import { LayerProps } from 'shared/map-exports';
import { useMemo } from 'react';
import {
  ExternalFeatureLayerProps,
  ExternalLayerStylesInput,
} from './ExternalFeatureLayer.types';
import { EmbeddedStyleLineLayer } from './EmbeddedStyleLineLayer';
import { getSimpleStyleLineClickListenerLayerId } from './ExternalFeatureLayer.utils';

type LineLayerProps = ExternalFeatureLayerProps;

const getLineLayerStyles = (input: ExternalLayerStylesInput): LayerProps => {
  if (input.displayStyleType !== 'simple_single_color') {
    throw new Error(
      'Line layer styles require simple_single_color display style',
    );
  }
  const { sourceLayer, color } = input;
  return {
    type: 'line',
    'source-layer': sourceLayer,
    paint: {
      'line-color': color,
      'line-width': ['interpolate', ['linear'], ['zoom'], 8, 2, 18, 6],
    },
  };
};

export const SimpleLineLayer = (props: LineLayerProps): JSX.Element => {
  const { sourceId, featureLayer } = props;
  const { shortName, displayStyleData } = featureLayer;

  const updatedFeatureLayer = useMemo(() => {
    const lineStyle = getLineLayerStyles({
      sourceLayer: shortName,
      ...displayStyleData,
    });
    const featureLayerCopy = { ...featureLayer };
    featureLayerCopy.displayStyleData = {
      layers: [{ ...lineStyle, id: `${sourceId}_line` }],
      clickListenerLayerId: getSimpleStyleLineClickListenerLayerId(sourceId),
      displayStyleType: 'embedded',
    };
    return featureLayerCopy;
  }, [sourceId, shortName, displayStyleData, featureLayer]);

  return (
    <EmbeddedStyleLineLayer {...props} featureLayer={updatedFeatureLayer} />
  );
};
